// Since CSRF tokens are immutable entities, we will use `swr/immutable`
import useSWRImmutable from "swr/immutable"

const CSRF_REQUEST_PATH = "/csrf-token"

export interface CSRF {
  param: string
  token: string
  error: any
}

/**
 * A hook that fetches Rails CSRF tokens. Pass `enabled` as false to skip the
 * request when the caller has nothing to send.
 */
export const useCsrfToken = (enabled = true): CSRF => {
  const key = enabled ? CSRF_REQUEST_PATH : null
  const { data, error } = useSWRImmutable<CSRF>(key, async (url: string) => {
    const response = await fetch(url)

    if (!response.ok) {
      return Promise.reject(
        new Error(`An error occurred while fetching the CSRF token: (${response.status})`),
      )
    }

    return await response.json()
  })

  return {
    param: data?.param || "",
    token: data?.token || "",
    error,
  }
}
